<template>
  <div class="page-field">
    <div class="page-title" @click="sheetVisible = true">{{ group }}</div>
    <div class="page-part">
      <mt-field
        label="A4:"
        placeholder="单位箱(5包/箱)"
        type="number"
        v-model="a4"
      ></mt-field>
      <mt-field
        v-show="model === '4180'"
        label="相纸:"
        placeholder="单位(包)"
        type="number"
        v-model="l5"
      ></mt-field>
      <mt-field
        v-show="model === '552' || model === '4180'"
        label="黑墨:"
        placeholder="单位(个)"
        type="number"
        v-model="black"
      ></mt-field>
      <mt-field
        v-show="model === '552' || model === '4180'"
        label="红墨:"
        placeholder="单位(个)"
        type="number"
        v-model="magenta"
      ></mt-field>
      <mt-field
        v-show="model === '552' || model === '4180'"
        label="青墨:"
        placeholder="单位(个)"
        type="number"
        v-model="cyan"
      ></mt-field>
      <mt-field
        v-show="model === '552' || model === '4180'"
        label="黄墨:"
        placeholder="单位(个)"
        type="number"
        v-model="yellow"
      ></mt-field>
      <mt-field
        v-show="model === '5590'"
        label="硒鼓+鼓粉:"
        placeholder="单位(套)"
        type="number"
        v-model="drum"
      ></mt-field>
      <mt-field
        label="其他耗材:"
        placeholder="如：订书钉1盒"
        type="textarea"
        rows="3"
        v-model="ex"
      ></mt-field>
      <mt-field
        label="收货人"
        placeholder="请输入收货人姓名"
        :attr="{ maxlength: 10 }"
        v-model="receiver"
      ></mt-field>
      <mt-field
        label="手机号"
        placeholder="请输入手机号"
        type="tel"
        v-model="phone"
      ></mt-field>
      <mt-field
        label="地址"
        placeholder="请输入收货地址：省/市/区+详细地址"
        v-model="address"
      ></mt-field>
    </div>
    <div class="page-part">
      <mt-button @click.native="submit" class="btn">提交</mt-button>
    </div>
    <mt-actionsheet
      :actions="actions"
      v-model="sheetVisible"
      cancel-text=""
    ></mt-actionsheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { MessageBox } from 'mint-ui';
import { getGroups, apply } from "../../../../service";
export default {
  name: "Apply",
  data() {
    return {
      groups: [],
      sheetVisible: false,
      group: "请选择分组",
      model: "",
      a4: null,
      l5: null,
      black: null,
      magenta: null,
      cyan: null,
      yellow: null,
      drum: null,
      ex: "",
      phone: "",
      receiver: "",
      address: ""
    };
  },
  computed: {
    ...mapGetters({
      tel: "user/tel"
    }),
    actions: function() {
      if (this.groups && this.groups.length > 0) {
        return this.groups.map(g => {
          return {
            name: g.name,
            method: () => {
              this.changeGroup(g);
            }
          };
        });
      }
      return [];
    }
  },
  created() {
    this.fetchGroups();
  },
  methods: {
    fetchGroups() {
      getGroups(this.tel).then(({ status, data: { code, data } }) => {
        if (status === 200 && code === 0) {
          this.groups = data;
          this.group = data[0].name;
          this.model = data[0].model;
        }
      });
    },
    changeGroup(g) {
      this.group = g.name;
      this.model = g.model;
    },
    toInt(param) {
        if (param === undefined || param === null) {
            return 0
        }
        return param
    },
    submit() {
        let message = '机型：'+this.model+'; 申请清单：';
        if (this.a4 > 0) {
            message += 'A4纸：'+ this.toInt(this.a4) +'箱、'
        }
        if (this.model === '5590' && this.drum > 0) {
            message += '硒鼓+鼓粉：'+ this.toInt(this.drum) +'套、'
        } else {
            if (this.black > 0) {
                message += '黑墨：'+ this.toInt(this.black) +'个、'
            }
            if (this.magenta > 0) {
                message += '红墨：'+ this.toInt(this.magenta) +'个、'
            }
            if (this.cyan > 0) {
                message += '青墨：'+ this.toInt(this.cyan) +'个、'
            }
            if (this.yellow > 0) {
                message += '黄墨：'+ this.toInt(this.yellow) +'个、'
            }
        }
        if (this.l5 > 0) {
            message += '相纸：' + this.toInt(this.l5) + '包、'
        }
        if (this.ex !== "") {
            message += this.ex
        }
        MessageBox.confirm(message, '请再次确认耗材申请信息',{
            showCancelButton: true,
            confirmButtonText: '确认提交'
        }).then(action => {
           console.log(action);
            if (this.a4 > 0) {
              apply({
                type: 1,
                deviceModel: this.model,
                group: this.group.split('-')[0],
                tel: this.tel,
                paperA4: this.a4,
                receiver: this.receiver,
                phone: this.phone,
                address: this.address
              });
            }
            if (
              this.black > 0 ||
              this.magenta > 0 ||
              this.cyan > 0 ||
              this.yellow > 0 ||
              this.drum > 0
            ) {
              apply({
                type: 2,
                deviceModel: this.model,
                group: this.group.split('-')[0],
                tel: this.tel,
                black: this.black || 0,
                magenta: this.magenta || 0,
                cyan: this.cyan || 0,
                yellow: this.cyan || 0,
                drum: this.drum || 0,
                receiver: this.receiver,
                phone: this.phone,
                address: this.address
              });
            }
            if (this.ex !== "" || this.l5 > 0) {
              apply({
                type: 3,
                deviceModel: this.model,
                group: this.group.split('-')[0],
                tel: this.tel,
                ex: this.ex,
                paperL5: this.l5,
                receiver: this.receiver,
                phone: this.phone,
                address: this.address
              });
            }
            MessageBox.alert("耗材提交成功，请关闭此页面查看申请信息")
        }).catch(e => {
            console.log(e)
        });
    }
  }
};
</script>

<style lang="less" scoped>
  .mint-msgbox-message {
    color: #999;
    margin: 0;
    /* text-align: center; */
    line-height: 36px;
  }
  .page-title {
    font-size: 18px;
    font-weight: bold;
  }
  .page-field {
    margin-bottom: 60px;
  }
  .page-part {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home/children/Apply/index.vue